// extracted by mini-css-extract-plugin
module.exports = {"successModalDescription":"RoadmapFeatureRequestSuccessModal_successModalDescription__UIuJ9"};